module.exports = __webpack_public_path__ + "8e08d8cb381c01f16c0bf8c23b477c5c.png";